import React from 'react';
import { motion } from 'framer-motion';
import { LinkedIn, Instagram, Facebook, YouTube } from '@mui/icons-material';
import XLogo from '../XLogo';

const socialLinks = [
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/bizanimedia', Icon: LinkedIn },
  { name: 'Instagram', href: 'https://www.instagram.com/bizanimedia', Icon: Instagram },
  { name: 'Facebook', href: 'https://www.facebook.com/bizanimedia', Icon: Facebook },
  { name: 'X', href: 'https://x.com/bizanimedia', Icon: XLogo },
  { name: 'YouTube', href: 'https://www.youtube.com/@bizanimedia', Icon: YouTube }
];

const ContactSocial: React.FC = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-headline font-bold mb-6" style={{ color: '#EF3F23' }}>
            Connect With Us
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto font-body mb-10">
            Follow us on social media for the latest updates and behind-the-scenes content
          </p>
          <div className="flex flex-wrap justify-center gap-5">
            {socialLinks.map(({ name, href, Icon }, index) => (
              <motion.a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                className="flex items-center justify-center w-14 h-14 rounded-full bg-gray-800 text-gray-400 hover:bg-bizani-orange hover:text-white transition-all duration-300"
                aria-label={name}
                title={name}
              >
                {Icon === XLogo ? <Icon size={26} /> : <Icon style={{ fontSize: 26 }} />}
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSocial;
